export default "__VITE_ASSET__UAzMHuJp__"